export default __webpack_public_path__ + "static/media/layers.b688a49a.svg";